export default __webpack_public_path__ + "static/logo-4e8f72af304488697dc7e8cacea164a5.svg";